import React, { useEffect, useState } from 'react';
import {
  Select,
  InputLabel,
  FormControl,
  SelectChangeEvent,
} from '@mui/material';
import { CustomSelectProps } from '../types';

function CustomSelect<T = string>({
  label,
  options,
  value,
  minWidth = 100,
  onChange,
  renderOption,
  className,
  dense,
  renderValue,
}: CustomSelectProps<T>) {
  const [selectedOption, setSelectedOption] = useState(value ?? '');

  useEffect(() => {
    setSelectedOption(value ?? '');
  }, [value]);

  const handleSelectedOption = (event: SelectChangeEvent) => {
    setSelectedOption(event.target.value);
    onChange?.({ name: event.target.name, value: event.target.value });
  };

  return (
    <FormControl
      variant="filled"
      sx={{
        m: dense ? 0 : 1,
        minWidth,
        ...(dense &&
          typeof minWidth === 'number' && {
            width: `${minWidth}px`,
            maxWidth: `${minWidth}px`,
            minWidth: `${minWidth}px`,
            flexShrink: 0,
            boxSizing: 'border-box',
          }),
      }}
    >
      <InputLabel
        size="small"
        sx={{ fontSize: (theme) => theme.spacing(dense ? 1.375 : 1.5) }}
      >
        {label}
      </InputLabel>
      <Select
        name={label.toLocaleLowerCase()}
        size="small"
        onChange={handleSelectedOption}
        value={selectedOption}
        IconComponent={() => null}
        className={className}
        displayEmpty={Boolean(renderValue)}
        MenuProps={
          dense
            ? {
                anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
                transformOrigin: { vertical: 'top', horizontal: 'left' },
              }
            : undefined
        }
        renderValue={
          renderValue
            ? (v) =>
                renderValue(
                  typeof v === 'string' || typeof v === 'number'
                    ? String(v)
                    : '',
                )
            : undefined
        }
        sx={
          dense
            ? {
                width: '100%',
                maxWidth: '100%',
                boxSizing: 'border-box',
                '& .MuiFilledInput-root': {
                  boxSizing: 'border-box',
                },
              }
            : undefined
        }
      >
        {options.map(renderOption)}
      </Select>
    </FormControl>
  );
}

export default CustomSelect;
